import React from 'react';
import { Drawer, Box, IconButton, Container} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDrawer } from '../../Context/RightDrawerContext';

const RightDrawer = () => {
    const { isDrawerOpen, openDrawer, closeDrawer, toggleDrawer, drawerContent } = useDrawer();
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => closeDrawer()}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 600, md: 800 },
          boxSizing: 'border-box',
        },
      }}
    >
      <Container sx={{mt: 7, mb: 0}}/>
      <Box sx={{ p: 1 }}>
        {/* Close button */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0 }}>
          <IconButton 
            onClick={() => closeDrawer()}
            sx={{ color: 'text.primary' }}
          >
            <Close />
          </IconButton>
        </Box>

        {/* Drawer content */}
        {drawerContent}
      </Box>
    </Drawer>
  );
};

export default RightDrawer;